import { booleanOptions, Input, MultiSearchForm, useDebouncedSearch } from "@";
import { searchValues } from "../utils/options";

const MultiSearch = ({ onSubmit, search, updateSearch }) => {
  useDebouncedSearch(onSubmit, search.values, searchValues);

  const renderInput = (label, type, valueKey, list = null) => (
    <Input
      star
      label={label}
      type={type}
      list={list}
      value={search.values[valueKey]}
      change={(e) =>
        updateSearch({
          values: { ...search.values, [valueKey]: e.target.value },
        })
      }
    />
  );

  return (
    <>
      {/* Form for searching donors */}
      <MultiSearchForm
        show={search.show}
        onSubmit={onSubmit}
        className="multi-search-form xl:grid-cols-5"
        reset={() => updateSearch({ values: searchValues })}
      >
        {/* Input field for searching donors */}
        {renderInput("كلمة البحث", "text", "title")}

        {/* Input field for selecting donors or non-donors */}
        {renderInput("متبرع سابق", "select", "isDonor", booleanOptions)}

        {/* Input field for selecting active or inactive donors */}
        {renderInput("نشط", "select", "donorStatus", booleanOptions)}

        {/* Input field for selecting donors who want to receive message or not */}
        {renderInput(
          "استقبال الرسالة الجماعية",
          "select",
          "stopMessageGroup",
          booleanOptions,
        )}
      </MultiSearchForm>
    </>
  );
};

export default MultiSearch;
